"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Node_privateKey, _Node_publicKey, _Seed_seed;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Seed = exports.Node = void 0;
const secp256k1_1 = __importDefault(require("@bitcoinerlab/secp256k1"));
const bip32crypto = __importStar(require("bip32/src/crypto"));
const isolation_1 = require("../../../isolation");
const types_1 = require("../../types");
const Ed25519 = __importStar(require("./ed25519"));
const revocable_1 = require("./revocable");
__exportStar(require("../../core/bip32"), exports);
class Node extends (0, revocable_1.Revocable)(class {
}) {
    constructor(privateKey, chainCode, explicitPath) {
        super();
        _Node_privateKey.set(this, void 0);
        _Node_publicKey.set(this, void 0);
        // We avoid handing the private key to any non-platform code -- including our type-checking machinery.
        if (privateKey.length !== 32)
            throw new Error("bad private key length");
        __classPrivateFieldSet(this, _Node_privateKey, (0, types_1.safeBufferFrom)(privateKey), "f");
        this.addRevoker(() => __classPrivateFieldGet(this, _Node_privateKey, "f").fill(0));
        this.chainCode = (0, types_1.safeBufferFrom)((0, types_1.checkType)(isolation_1.Core.BIP32.ChainCode, chainCode));
        this.explicitPath = explicitPath;
    }
    static create(privateKey, chainCode, explicitPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const obj = new Node(privateKey, chainCode, explicitPath);
            return (0, revocable_1.revocable)(obj, (x) => obj.addRevoker(x));
        });
    }
    getPublicKey() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            __classPrivateFieldSet(this, _Node_publicKey, (_a = __classPrivateFieldGet(this, _Node_publicKey, "f")) !== null && _a !== void 0 ? _a : (0, types_1.checkType)(isolation_1.Core.SecP256K1.CompressedPoint, secp256k1_1.default.pointFromScalar(__classPrivateFieldGet(this, _Node_privateKey, "f"), true)), "f");
            return __classPrivateFieldGet(this, _Node_publicKey, "f");
        });
    }
    getChainCode() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.chainCode;
        });
    }
    ecdsaSign(digestAlgorithm, msg, counter) {
        return __awaiter(this, void 0, void 0, function* () {
            const recoverableSig = yield (() => __awaiter(this, void 0, void 0, function* () {
                if (digestAlgorithm === null) {
                    (0, types_1.assertType)((0, types_1.ByteArray)(32), msg);
                    return yield this.ecdsaSignRecoverable(digestAlgorithm, msg, counter);
                }
                else {
                    return yield this.ecdsaSignRecoverable(digestAlgorithm, msg, counter);
                }
            }))();
            return isolation_1.Core.SecP256K1.RecoverableSignature.sig(recoverableSig);
        });
    }
    ecdsaSignRecoverable(digestAlgorithm, msg, counter) {
        return __awaiter(this, void 0, void 0, function* () {
            counter === undefined || types_1.Uint32.assert(counter);
            digestAlgorithm === null || isolation_1.Core.Digest.AlgorithmName(32).assert(digestAlgorithm);
            const msgOrDigest = digestAlgorithm === null
                ? (0, types_1.checkType)((0, types_1.ByteArray)(32), msg)
                : isolation_1.Core.Digest.Algorithms[digestAlgorithm]((0, types_1.checkType)((0, types_1.ByteArray)(), msg));
            const entropy = counter === undefined ? undefined : Buffer.alloc(32);
            entropy === null || entropy === void 0 ? void 0 : entropy.writeUInt32BE(counter !== null && counter !== void 0 ? counter : 0, 24);
            return yield isolation_1.Core.SecP256K1.RecoverableSignature.fromSignature((0, types_1.checkType)(isolation_1.Core.SecP256K1.Signature, secp256k1_1.default.sign(Buffer.from(msgOrDigest), __classPrivateFieldGet(this, _Node_privateKey, "f"), entropy)), null, msgOrDigest, yield this.getPublicKey());
        });
    }
    derive(index) {
        return __awaiter(this, void 0, void 0, function* () {
            types_1.Uint32.assert(index);
            const serP = Buffer.alloc(37);
            if (index < 0x80000000) {
                serP.set(isolation_1.Core.SecP256K1.CompressedPoint.from(yield this.getPublicKey()), 0);
            }
            else {
                serP.set(__classPrivateFieldGet(this, _Node_privateKey, "f"), 1);
            }
            serP.writeUInt32BE(index, 33);
            const I = bip32crypto.hmacSHA512(this.chainCode, serP);
            const IL = I.slice(0, 32);
            const IR = I.slice(32, 64);
            const ki = secp256k1_1.default.privateAdd(__classPrivateFieldGet(this, _Node_privateKey, "f"), IL);
            if (ki === null)
                throw new Error("ki is null; this should be cryptographically impossible");
            const out = yield Node.create(ki, IR);
            this.addRevoker(() => { var _a; return (_a = out.revoke) === null || _a === void 0 ? void 0 : _a.call(out); });
            return out;
        });
    }
    ecdh(publicKey, digestAlgorithm) {
        return __awaiter(this, void 0, void 0, function* () {
            isolation_1.Core.SecP256K1.CurvePoint.assert(publicKey);
            digestAlgorithm === undefined || isolation_1.Core.Digest.AlgorithmName(32).assert(digestAlgorithm);
            return (0, types_1.checkType)((0, types_1.ByteArray)(32), yield this._ecdh(publicKey, digestAlgorithm));
        });
    }
    ecdhRaw(publicKey) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, types_1.checkType)(isolation_1.Core.SecP256K1.UncompressedPoint, yield this._ecdh(publicKey, null));
        });
    }
    _ecdh(publicKey, digestAlgorithm) {
        return __awaiter(this, void 0, void 0, function* () {
            isolation_1.Core.SecP256K1.CurvePoint.assert(publicKey);
            digestAlgorithm === undefined || digestAlgorithm === null || isolation_1.Core.Digest.AlgorithmName(32).assert(digestAlgorithm);
            const sharedFieldElement = (0, types_1.checkType)(isolation_1.Core.SecP256K1.UncompressedPoint, secp256k1_1.default.pointMultiply(Buffer.from(publicKey), __classPrivateFieldGet(this, _Node_privateKey, "f"), false));
            if (digestAlgorithm === null)
                return sharedFieldElement;
            let out = isolation_1.Core.SecP256K1.CurvePoint.x(sharedFieldElement);
            if (digestAlgorithm !== undefined)
                out = isolation_1.Core.Digest.Algorithms[digestAlgorithm](out);
            return out;
        });
    }
}
exports.Node = Node;
_Node_privateKey = new WeakMap(), _Node_publicKey = new WeakMap();
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class Seed extends (0, revocable_1.Revocable)(class {
}) {
    constructor(seed) {
        super();
        _Seed_seed.set(this, void 0);
        __classPrivateFieldSet(this, _Seed_seed, (0, types_1.safeBufferFrom)(seed), "f");
        this.addRevoker(() => __classPrivateFieldGet(this, _Seed_seed, "f").fill(0));
    }
    static create(seed) {
        return __awaiter(this, void 0, void 0, function* () {
            const obj = new Seed(seed);
            return (0, revocable_1.revocable)(obj, (x) => obj.addRevoker(x));
        });
    }
    toSecp256k1MasterKey() {
        return __awaiter(this, void 0, void 0, function* () {
            const hmacKey = (0, types_1.safeBufferFrom)(new TextEncoder().encode("Bitcoin seed"));
            const I = (0, types_1.safeBufferFrom)(bip32crypto.hmacSHA512((0, types_1.safeBufferFrom)(hmacKey), __classPrivateFieldGet(this, _Seed_seed, "f")));
            const IL = I.subarray(0, 32);
            const IR = I.subarray(32, 64);
            const out = yield Node.create(IL, IR);
            this.addRevoker(() => { var _a; return (_a = out.revoke) === null || _a === void 0 ? void 0 : _a.call(out); });
            return out;
        });
    }
    toEd25519MasterKey() {
        return __awaiter(this, void 0, void 0, function* () {
            const hmacKey = (0, types_1.safeBufferFrom)(new TextEncoder().encode("ed25519 seed"));
            const I = (0, types_1.safeBufferFrom)(bip32crypto.hmacSHA512(hmacKey, __classPrivateFieldGet(this, _Seed_seed, "f")));
            const IL = I.subarray(0, 32);
            const IR = I.subarray(32, 64);
            const out = yield Ed25519.Node.create(IL, IR);
            this.addRevoker(() => { var _a; return (_a = out.revoke) === null || _a === void 0 ? void 0 : _a.call(out); });
            return out;
        });
    }
}
exports.Seed = Seed;
_Seed_seed = new WeakMap();
//# sourceMappingURL=bip32.js.map